export const menuMainCommand = 'menu:main';
